const SITE_URL = "https://magyne.com";

export const organizationSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  "@id": `${SITE_URL}/#organization`,
  name: "Magyne",
  url: SITE_URL,
  logo: `${SITE_URL}/logo.png`,
  description:
    "Magyne is a SaaS and ERP platform providing business management software for organizations across Africa.",
};

export const softwareSchema = {
  "@context": "https://schema.org",
  "@type": "SoftwareApplication",
  "@id": `${SITE_URL}/#software`,
  name: "Magyne ERP",
  applicationCategory: "BusinessApplication",
  operatingSystem: "Web",
  url: SITE_URL,
  description:
    "Magyne ERP is a SaaS business management platform for schools, healthcare organizations, local authorities, hotels, car washes and businesses.",
  publisher: {
    "@id": `${SITE_URL}/#organization`,
  },
};

export const homeSchema = {
  "@context": "https://schema.org",
  "@graph": [
    organizationSchema,
    softwareSchema,
  ],
};